export const USER_TYPE = {
	academy: "academy",
	playground: "playground",
	viewer: "viewer",
	scouting: "scouting",
	player: "player",
	coach: "coach",
	company: "company",
	branch: "branch",
	federation: "federation",
	cafe: "cafe",
	tournament: "tournament",
};

export const USERS_TYPE = {
	players: "players",
	academies: "academies",
	playgrounds: "playgrounds",
	viewers: "viewers",
	scoutings: "scoutings",
	coaches: "coaches",
	company: "company",
	branch: "branch",
	federations: "federations",
	cafes: "cafes",
	tournaments: "tournaments",
};

export type UserType = (typeof USER_TYPE)[keyof typeof USER_TYPE];
export type UsersType = (typeof USERS_TYPE)[keyof typeof USERS_TYPE];
